<template>
    <div class="nav_footer_header">
      <div class="nav_footer_header_content clearfix">
        <img class="nav_footer_header_content_img" @click="goHome" src="../assets/logo.png" alt="">
        <img class="nav_footer_header_content_img1" src="../assets/home/home_phone.png" alt="">  
        <p class="nav_footer_header_content_phone">{{customer.phone}}</p>
        <div class="nav_footer_header_content_type" v-if="userMessage.token">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link nav_footer_header_content_type_img">
              <img v-if="userMessage.avatar" :src="$imgUrl + userMessage.avatar" alt="">
              <img v-else src="../assets/default_user.png" alt="">
              <p style="position: relative;">{{userMessage.username}}</p>
            </span>
              <el-dropdown-menu style="top:60px" slot="dropdown">
                <el-dropdown-item command="/message">消息提醒</el-dropdown-item>
                <el-dropdown-item command="/wallet">我的钱包</el-dropdown-item>
                <el-dropdown-item command="/orderList">我的订单</el-dropdown-item>
                <el-dropdown-item command="/address">地址簿</el-dropdown-item>
                <el-dropdown-item command="/invitation">邀请返现</el-dropdown-item>
                <!-- <el-dropdown-item command="/authentication">同行认证</el-dropdown-item> -->
                <el-dropdown-item command="layout" divided>退出</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown>
          
          
        </div>
        <div class="nav_footer_header_content_type" v-if="!userMessage.token">
          <p @click="$emit('login','loginVisible')">登录/注册</p>
        </div>
        <el-popover
          placement="bottom"
          width="224"
          trigger="click">
          <img style="width:200px" src="../assets/erweima_logo.png" alt="">
          <div slot="reference" class="nav_footer_header_content_user">
            <img src="../assets/home/home_mobile.png" alt="">
            <p>移动端</p>
          </div>
        </el-popover>
      </div>
    </div>
</template>

<script>
export default {
   data (){
       return {
         userMessage:JSON.parse(localStorage.getItem('userMessage') || '{}')
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       goHome(){
         if(this.$route.path == '/home'){
           return
         }
         this.$router.push({path:'/home'});
       },
       getCustomerPhone(){
          this.$get('CustomerServicePhone',{})
          .then(data => {
            this.customer.phone = data;
            localStorage.setItem('phone',data)
            this.$forceUpdate();
          },error => {
            this.$message.error(error);
          });
        },
       handleCommand(command){
         if(command == 'layout'){
           this.userMessage = {};
           localStorage.clear();
           if(this.$route.path != '/home'){
             this.$router.push('/home');
           }
         }else{
           if(this.$route.path != command){
             this.$router.push(command);
           }
           
         }
       }
   },
   updated(){
   },
   created() {
     this.getCustomerPhone();
      this.$eventBus.$on('changeUserInfo' , data => {
        this.userMessage = data;
      });
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.nav_footer{
  &_header{
    width:100%;
    height: 80px;
    background: #202329;
    line-height: 60px;
    display: flex;
    justify-content:center;
    &_content{
      width: 1160px;
      height: 80px;
      padding: 0 10px;
      padding: 14px;
      &_img{
        width:203px;
        float: left;
        cursor: pointer;
        margin-top: -6px;
      }
      &_img1{
        width:40px;
        margin: 8px 12px 0 27px;
        float: left;
      }
      &_phone{
        font-size: 26px;
        color:#5999FF;
        float: left;
        margin-top: -4px;
      }
      &_user{
        float:right;
        display: flex;
        align-items:center;
        cursor: pointer;
        user-select:none;
        img{
          width:20px;
          margin-right:11px;
        }
        p{
          color:#fff;
          display: inline-block;
        }
      }
      &_type{
        float:right;
        display: flex;
        align-items:center;
        cursor: pointer;
        user-select:none;
        margin-left:40px;
        &_img{
          display: flex;
          align-items: center;
        }
        img{
          width:52px;
          height: 52px;
          margin-right:11px;
          border-radius: 26px;
        }
        p{
          color:#fff;
          display: inline-block;
          
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/navHeader.vue